import accountSettingsDe from './locales/de/accountSettings.json';
import componentsDe from './locales/de/components.json';
import dailySurveyOverviewDe from './locales/de/dailySurveyOverview.json';
import dataExplorerDe from './locales/de/dataExplorer.json';
import getStartedDe from './locales/de/getStarted.json';
import integrationsDe from './locales/de/integrations.json';
import leaderInsightsDe from './locales/de/leaderInsights.json';
import onboardingDe from './locales/de/onboarding.json';
import questionHistoryDe from './locales/de/questionHistory.json';
import questionLibraryDe from './locales/de/questionLibrary.json';
import questionScheduleDe from './locales/de/questionSchedule.json';
import settingsDe from './locales/de/settings.json';
import surveysOverviewDe from './locales/de/surveysOverview.json';
import surveysTemplatesDe from './locales/de/surveysTemplates.json';
import accountSettingsEn from './locales/en/accountSettings.json';
import componentsEn from './locales/en/components.json';
import dailySurveyOverviewEn from './locales/en/dailySurveyOverview.json';
import dataExplorerEn from './locales/en/dataExplorer.json';
import getStartedEn from './locales/en/getStarted.json';
import integrationsEn from './locales/en/integrations.json';
import leaderInsightsEn from './locales/en/leaderInsights.json';
import onboardingEn from './locales/en/onboarding.json';
import questionHistoryEn from './locales/en/questionHistory.json';
import questionLibraryEn from './locales/en/questionLibrary.json';
import questionScheduleEn from './locales/en/questionSchedule.json';
import settingsEn from './locales/en/settings.json';
import surveysOverviewEn from './locales/en/surveysOverview.json';
import surveysTemplatesEn from './locales/en/surveysTemplates.json';
import accountSettingsEs from './locales/es/accountSettings.json';
import componentsEs from './locales/es/components.json';
import dailySurveyOverviewEs from './locales/es/dailySurveyOverview.json';
import dataExplorerEs from './locales/es/dataExplorer.json';
import getStartedEs from './locales/es/getStarted.json';
import integrationsEs from './locales/es/integrations.json';
import leaderInsightsEs from './locales/es/leaderInsights.json';
import onboardingEs from './locales/es/onboarding.json';
import questionHistoryEs from './locales/es/questionHistory.json';
import questionLibraryEs from './locales/es/questionLibrary.json';
import questionScheduleEs from './locales/es/questionSchedule.json';
import settingsEs from './locales/es/settings.json';
import surveysOverviewEs from './locales/es/surveysOverview.json';
import surveysTemplatesEs from './locales/es/surveysTemplates.json';
import accountSettingsFr from './locales/fr/accountSettings.json';
import componentsFr from './locales/fr/components.json';
import dailySurveyOverviewFr from './locales/fr/dailySurveyOverview.json';
import dataExplorerFr from './locales/fr/dataExplorer.json';
import getStartedFr from './locales/fr/getStarted.json';
import integrationsFr from './locales/fr/integrations.json';
import leaderInsightsFr from './locales/fr/leaderInsights.json';
import onboardingFr from './locales/fr/onboarding.json';
import questionHistoryFr from './locales/fr/questionHistory.json';
import questionLibraryFr from './locales/fr/questionLibrary.json';
import questionScheduleFr from './locales/fr/questionSchedule.json';
import settingsFr from './locales/fr/settings.json';
import surveysOverviewFr from './locales/fr/surveysOverview.json';
import surveysTemplatesFr from './locales/fr/surveysTemplates.json';
import accountSettingsSv from './locales/sv/accountSettings.json';
import componentsSv from './locales/sv/components.json';
import dailySurveyOverviewSv from './locales/sv/dailySurveyOverview.json';
import dataExplorerSv from './locales/sv/dataExplorer.json';
import getStartedSv from './locales/sv/getStarted.json';
import integrationsSv from './locales/sv/integrations.json';
import leaderInsightsSv from './locales/sv/leaderInsights.json';
import onboardingSv from './locales/sv/onboarding.json';
import questionHistorySv from './locales/sv/questionHistory.json';
import questionLibrarySv from './locales/sv/questionLibrary.json';
import questionScheduleSv from './locales/sv/questionSchedule.json';
import settingsSv from './locales/sv/settings.json';
import surveysOverviewSv from './locales/sv/surveysOverview.json';
import surveysTemplatesSv from './locales/sv/surveysTemplates.json';

export const resources = {
  de: {
    components: componentsDe,
    questionHistory: questionHistoryDe,
    getStarted: getStartedDe,
    dailySurveyOverview: dailySurveyOverviewDe,
    leaderInsights: leaderInsightsDe,
    questionLibrary: questionLibraryDe,
    questionSchedule: questionScheduleDe,
    onboarding: onboardingDe,
    settings: settingsDe,
    dataExplorer: dataExplorerDe,
    surveysTemplates: surveysTemplatesDe,
    surveysOverview: surveysOverviewDe,
    integrations: integrationsDe,
    accountSettings: accountSettingsDe,
  },
  en: {
    components: componentsEn,
    questionHistory: questionHistoryEn,
    getStarted: getStartedEn,
    dailySurveyOverview: dailySurveyOverviewEn,
    leaderInsights: leaderInsightsEn,
    questionLibrary: questionLibraryEn,
    questionSchedule: questionScheduleEn,
    onboarding: onboardingEn,
    settings: settingsEn,
    dataExplorer: dataExplorerEn,
    surveysTemplates: surveysTemplatesEn,
    surveysOverview: surveysOverviewEn,
    integrations: integrationsEn,
    accountSettings: accountSettingsEn,
  },
  es: {
    components: componentsEs,
    questionHistory: questionHistoryEs,
    getStarted: getStartedEs,
    dailySurveyOverview: dailySurveyOverviewEs,
    leaderInsights: leaderInsightsEs,
    questionLibrary: questionLibraryEs,
    questionSchedule: questionScheduleEs,
    onboarding: onboardingEs,
    settings: settingsEs,
    dataExplorer: dataExplorerEs,
    surveysTemplates: surveysTemplatesEs,
    surveysOverview: surveysOverviewEs,
    integrations: integrationsEs,
    accountSettings: accountSettingsEs,
  },
  fr: {
    components: componentsFr,
    questionHistory: questionHistoryFr,
    getStarted: getStartedFr,
    dailySurveyOverview: dailySurveyOverviewFr,
    leaderInsights: leaderInsightsFr,
    questionLibrary: questionLibraryFr,
    questionSchedule: questionScheduleFr,
    onboarding: onboardingFr,
    settings: settingsFr,
    dataExplorer: dataExplorerFr,
    surveysTemplates: surveysTemplatesFr,
    surveysOverview: surveysOverviewFr,
    integrations: integrationsFr,
    accountSettings: accountSettingsFr,
  },
  sv: {
    components: componentsSv,
    questionHistory: questionHistorySv,
    getStarted: getStartedSv,
    dailySurveyOverview: dailySurveyOverviewSv,
    leaderInsights: leaderInsightsSv,
    questionLibrary: questionLibrarySv,
    questionSchedule: questionScheduleSv,
    onboarding: onboardingSv,
    settings: settingsSv,
    dataExplorer: dataExplorerSv,
    surveysTemplates: surveysTemplatesSv,
    surveysOverview: surveysOverviewSv,
    integrations: integrationsSv,
    accountSettings: accountSettingsSv,
  },
};
